
export const FETCH_WORKLIST_VISITS = "FETCH_WORKLIST_VISITS";
export const FETCH_WORKLIST_VISITS_START = "FETCH_WORKLIST_VISITS_START";
export const FETCH_WORKLIST_VISITS_SUCCESS = "FETCH_WORKLIST_VISITS_SUCCESS";
export const FETCH_WORKLIST_VISITS_ERROR = "FETCH_WORKLIST_VISITS_ERROR";

export const VIEW_WORKLIST_VISIT_LOADING_START = "VIEW_WORKLIST_VISIT_LOADING_START";
export const VIEW_WORKLIST_VISIT_LOADING_END = "VIEW_WORKLIST_VISIT_LOADING_END";

export const FETCH_MIP_RADIOLOGIST_USERS = "FETCH_MIP_RADIOLOGIST_USERS";
export const FETCH_MIP_RADIOLOGIST_USERS_SUCCESS = "FETCH_MIP_RADIOLOGIST_USERS_SUCCESS";
export const FETCH_MIP_RADIOLOGIST_USERS_ERROR = "FETCH_MIP_RADIOLOGIST_USERS_ERROR";

export const UPDATE_WORKLIST_VISIT_RADIOLOGIST = "UPDATE_WORKLIST_VISIT_RADIOLOGIST";
export const UPDATE_WORKLIST_VISIT_RADIOLOGIST_START = "UPDATE_WORKLIST_VISIT_RADIOLOGIST_START";
export const UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS = "UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS";
export const UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR = "UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR";

export const SET_WORKLIST_FILTER = "[COMMON] SET_WORKLIST_FILTER";
export const SET_WORKLIST_PAGINATION = "[COMMON] SET_WORKLIST_PAGINATION";

export const SET_ASSIGN_RADIOLOGIST_MODAL_CONFIG = "SET_ASSIGN_RADIOLOGIST_MODAL_CONFIG";

export const SET_ASSIGNGROUP_MEMBER_MODAL_CONFIG = "SET_ASSIGNGROUP_MEMBER_MODAL_CONFIG";

export const SHOW_WORKLIST_VISIT_MODAL = "[RADIOLOGIST_ASSIGNMENT] SHOW_WORKLIST_VISIT_MODAL";
export const HIDE_WORKLIST_VISIT_MODAL = "[RADIOLOGIST_ASSIGNMENT] HIDE_WORKLIST_VISIT_MODAL";
export const UPDATE_WORKLIST_VISIT_STUDY = "[RADIOLOGIST_ASSIGNMENT] UPDATE_WORKLIST_VISIT_STUDY";
export const UPDATE_WORKLIST_VISIT_STUDY_START = "[RADIOLOGIST_ASSIGNMENT] UPDATE_WORKLIST_VISIT_STUDY_START";
export const UPDATE_WORKLIST_VISIT_STUDY_SUCCESS = "[RADIOLOGIST_ASSIGNMENT] UPDATE_WORKLIST_VISIT_STUDY_SUCCESS";
export const UPDATE_WORKLIST_VISIT_STUDY_ERROR = "[RADIOLOGIST_ASSIGNMENT] UPDATE_WORKLIST_VISIT_STUDY_ERROR";

export const RESET_WORKLIST_VISITS_FILTER = "[MIS] RESET_WORKLIST_VISITS_FILTER";

export const fetchWorklistVisits = (payload) => {
    return {
        type: FETCH_WORKLIST_VISITS,
        payload
    };
};

export const updateWorklistVisitRadiologist = (payload, clearSelectedRow) => {
    return {
        type: UPDATE_WORKLIST_VISIT_RADIOLOGIST,
        payload,
        clearSelectedRow
    };
};

export const fetchMipRadiologyUsers = (payload) => {
    return {
        type: FETCH_MIP_RADIOLOGIST_USERS,
        payload
    };
}

export const setMisWorklistfilter = (searchFilter, sortConditions) => {
    return {
        type: SET_WORKLIST_FILTER,
        payload: {
            searchFilter,
            sortConditions
        }
    };
}

export const setAssignRadiologistModalConfig = (config) => {
    return {
        type: SET_ASSIGN_RADIOLOGIST_MODAL_CONFIG,
        config
    };
}

export const setAssignGroupMemberModalConfig = (config) => {
    return {
        type: SET_ASSIGNGROUP_MEMBER_MODAL_CONFIG,
        config
    };
}

export const showWorklistVisitModal = (selectedVisit) => {
    return {
        type: SHOW_WORKLIST_VISIT_MODAL,
        selectedVisit
    };
};

export const updateWorklistVisitStudy = (visit) => {
    return {
        type: UPDATE_WORKLIST_VISIT_STUDY,
        payload: visit
    };
};

export const closeWorklistVisitModal = () => {
    return {
        type: HIDE_WORKLIST_VISIT_MODAL
    };
};

export const resetWorklistVisitsFilter = () => {
    return {
        type: RESET_WORKLIST_VISITS_FILTER,
    };
}